// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.afis-icon-iball {
  font-size: 14px;
  color: #48baff;
}
.afis-icon-iball::after {
  content: ' ';
  font-size: 0.666em;
}
.v-popper__popper {
  padding: 10px;
}
.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-inner {
  top: 4px;
}
.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-outer {
  left: -2px;
  border-width: 7px;
  top: -4px;
}
.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-outer {
  left: -2px;
  border-width: 7px;
}
.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-inner {
  top: -1px;
}
.v-popper__arrow-inner {
  visibility: visible !important;
  border-color: white !important;
}
.v-popper__arrow-outer {
  border-color: #999 !important;
}
.v-popper__wrapper {
  max-width: 305px;
  min-width: 32px;
  min-height: 26px;
}
.v-popper__inner {
  background-color: #fff !important;
  color: #212121 !important;
  box-shadow: none;
  border: 1px #999 solid;
  padding: 6px !important;
  font-size: 12px;
  line-height: 13px;
  font-family: AvenirNextLTW01-Regular, Arial;
  text-align: left;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/components/global/IBallModal.vue","webpack://./IBallModal.vue"],"names":[],"mappings":"AACA;EACC,eAAA;EACA,cAAA;ACAD;ADCC;EACC,YAAA;EACA,kBAAA;ACCF;ADEA;EACC,aAAA;ACAD;ADEA;EACC,QAAA;ACAD;ADEA;EACC,UAAA;EACA,iBAAA;EACA,SAAA;ACAD;ADEA;EACC,UAAA;EACA,iBAAA;ACAD;ADEA;EACC,SAAA;ACAD;ADEA;EACC,8BAAA;EACA,8BAAA;ACAD;ADEA;EACC,6BAAA;ACAD;ADEA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;ACAD;ADEA;EACC,iCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA;ACAD","sourcesContent":["\n.afis-icon-iball {\n\tfont-size: 14px;\n\tcolor: #48baff;\n\t&::after {\n\t\tcontent: ' ';\n\t\tfont-size: 0.666em;\n\t}\n}\n.v-popper__popper {\n\tpadding: 10px;\n}\n.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-inner {\n\ttop: 4px;\n}\n.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-outer {\n\tleft: -2px;\n\tborder-width: 7px;\n\ttop: -4px;\n}\n.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-outer {\n\tleft: -2px;\n\tborder-width: 7px;\n}\n.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-inner {\n\ttop: -1px;\n}\n.v-popper__arrow-inner {\n\tvisibility: visible !important;\n\tborder-color: white !important;\n}\n.v-popper__arrow-outer {\n\tborder-color: #999 !important;\n}\n.v-popper__wrapper {\n\tmax-width: 305px;\n\tmin-width: 32px;\n\tmin-height: 26px;\n}\n.v-popper__inner {\n\tbackground-color: #fff !important;\n\tcolor: rgb(33,33,33) !important;\n\tbox-shadow: none;\n\tborder: 1px #999 solid;\n\tpadding: 6px !important;\n\tfont-size: 12px;\n\tline-height: 13px;\n\tfont-family: AvenirNextLTW01-Regular, Arial;\n\ttext-align: left;\n\twhite-space: normal;\n}\n",".afis-icon-iball {\n  font-size: 14px;\n  color: #48baff;\n}\n.afis-icon-iball::after {\n  content: ' ';\n  font-size: 0.666em;\n}\n.v-popper__popper {\n  padding: 10px;\n}\n.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-inner {\n  top: 4px;\n}\n.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-outer {\n  left: -2px;\n  border-width: 7px;\n  top: -4px;\n}\n.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-outer {\n  left: -2px;\n  border-width: 7px;\n}\n.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-inner {\n  top: -1px;\n}\n.v-popper__arrow-inner {\n  visibility: visible !important;\n  border-color: white !important;\n}\n.v-popper__arrow-outer {\n  border-color: #999 !important;\n}\n.v-popper__wrapper {\n  max-width: 305px;\n  min-width: 32px;\n  min-height: 26px;\n}\n.v-popper__inner {\n  background-color: #fff !important;\n  color: #212121 !important;\n  box-shadow: none;\n  border: 1px #999 solid;\n  padding: 6px !important;\n  font-size: 12px;\n  line-height: 13px;\n  font-family: AvenirNextLTW01-Regular, Arial;\n  text-align: left;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
